import React from "react";
import ProductSynthesis from "./Synthesis";
import ProductGallery from "./Gallery";
import EnhanceProductView from "./EnhanceProductView";
import { Grid, Cell } from "theme/components/templates/Grid";
import AddProductToWishlist from "theme/modules/Wishlist/AddProductToWishlist";

const ProductView = ({ galleryImageSizes = {}, ...props }) => {
  const { imageSizes, thumbSizes } = galleryImageSizes;
  return (
    <div className="container--desktop-only" key={props.product.sku}>
      <div className="product-view">
        <Grid>
          <Cell size="desktop-1">
            <div className="container--tablet-only">
              <div className="product-view__gallery">
                <ProductGallery
                  key={props.selectedSku}
                  product={props.product}
                  selectedSku={props.selectedSku}
                  numberOfVisibleThumbnails={4}
                  imageSizes={imageSizes}
                  thumbSizes={thumbSizes}
                />

                <div className="product-view__actions">
                  <AddProductToWishlist
                    sku={props.product.sku}
                    selectedOptions={props.selectedOptions}
                    selectedCustomOptions={props.selectedCustomOptions}
                    selectedBundleOptions={props.selectedBundleOptions}
                  />
                </div>
              </div>
            </div>
          </Cell>
          <Cell size="desktop-1">
            <div className="product-view__synthesis">
              <ProductSynthesis
                product={props.product}
                selectedOptions={props.selectedOptions}
                selectedCustomOptions={props.selectedCustomOptions}
                selectedBundleOptions={props.selectedBundleOptions}
                selectedGroupedItems={props.selectedGroupedItems}
                setOption={props.setOption}
                setCustomOption={props.setCustomOption}
                setBundleOption={props.setBundleOption}
                setGroupedItems={props.setGroupedItems}
                onProductAdded={() => props.onProductAdded(props.product)}
              />
            </div>
          </Cell>
        </Grid>
      </div>
    </div>
  );
};

export default EnhanceProductView()(ProductView);
